<template>
    <span class="control-bar-wrapper">
        <span class="controlbar-btn" v-html="svg"
            :id="uuid"
            @click="onclick">
        </span>
    </span>
</template>
<script>

import Icons from '../stuff/icons.json'

export default {
    name: 'ChartButton',
    props: ['index', 'name', 'label', 'tv_id', 'grid_id', 'ov_id', 'icon', 'display'],
    mounted() {
    },
    computed: {
        svg() {
            return this.icon || Icons[this.svg_file_name]
        },
        svg_file_name() {
            let id = this.$props.index
            if (this.$props.index === 'display') {
                id = this.$props.display ? 'display_on' : 'display_off'
            }
            return id + '.svg'
        },
        file_name() {
            let id = this.$props.index
            if (this.$props.index === 'display') {
                id = this.$props.display ? 'display_on' : 'display_off'
            }
            return id + '.png'
        },
        title() {
            return this.$props.label
        },
        uuid() {
            let tv = this.$props.tv_id
            let gr = this.$props.grid_id
            let ov = this.$props.ov_id
            return `${tv || this.$.uid}-btn-g${gr}-${ov}-${this.index}`
        },
        data_type() {
            return this.$props.grid_id === 0 ?
                "onchart" : "offchart"
        },
        data_index() {
            return this.$props.index
        }
    },
    methods: {
        onclick(event) {
            let button = event.target;
            this.$emit('chart-button-click', {
                button: this.$props.index,
                type: this.data_type,
                dataIndex: this.data_index,
                grid: this.$props.grid_id,
                overlay: this.$props.ov_id,
            })
        }
    }
}
</script>
<style>
.control-bar-label {

}
.controlbar-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: #5d606b;
    flex-flow: row-reverse nowrap;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0 2px 4px rgb(0 0 0 / 20%);
    border-radius: 50%;
    border-style: solid;
    border-color: rgba(255,255,255,0);
    background-color: rgba(255,255,255,0.5);
    pointer-events: auto;
    z-index: 1;
    opacity: 0.9;
    visibility: visible;
    flex-wrap: wrap;
    align-content: center;
    -ms-transform: translateY(-50%);
    transform: translateY(-50%);
}
.controlbar-btn > svg {
    width: 14px;
    height: 14px;
    flex: none;
    pointer-events: none;
}
.controlbar-btn:hover {
    border-radius: 50%;
    border-style: solid;
    border-color: rgba(255,255,255,0.2);
    background-color: rgba(255,255,255,0.6);
}
</style>
